import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Typography,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { END_USER_SHARED_PROGRAMME_PROGRESS_ROUTE } from '../../services/routes';

const SharedProgrammeCard = ({
  sharedProgrammeId,
  title,
  shortDescription,
  coverImageUrl,
  needsMembershipUpgrade,
  onClickSharedProgramme,
  cardWidth,
  isEnrolled,
  isCompleted,
  showStartButton,
  onClickStart,
}) => {
  const navigate = useNavigate();

  const actualWidth = cardWidth || 166;

  return (
    <div style={{ position: 'relative' }}>
      <Card
        onClick={(ev) => {
          ev.preventDefault();
          onClickSharedProgramme(sharedProgrammeId);
        }}
        className="shared-programme-card"
        sx={{
          width: actualWidth,
          height: 262,
          minWidth: actualWidth,
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'column',
        }}>
        <div style={{ position: 'relative' }}>
          <CardMedia sx={{ height: actualWidth - 26 }} image={coverImageUrl} />
          {needsMembershipUpgrade && (
            <LockIcon
              style={{ position: 'absolute', bottom: '10px', right: '10px' }}
            />
          )}
        </div>
        <CardContent
          sx={{
            padding: '8px !important',
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
          }}>
          <Typography
            variant="h4"
            sx={{ padding: 0 }}
            style={{ fontSize: '14px' }}>
            {title}
          </Typography>
          <Typography
            variant="body2"
            style={{
              lineClamp: 2,
              WebkitLineClamp: 2,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
            }}>
            {isEnrolled ? '' : shortDescription}
          </Typography>
        </CardContent>
        <div
          style={{
            display: 'flex',
            width: '100%',
            marginTop: 'auto',
            padding: '0 0 8px 0',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          {isEnrolled ? (
            <Button
              variant="contained"
              style={{
                borderRadius: '30px',
              }}
              onClick={(ev) => {
                ev.stopPropagation();
                navigate(
                  formatRoute(END_USER_SHARED_PROGRAMME_PROGRESS_ROUTE, {
                    sharedProgrammeId,
                  }),
                );
              }}>
              {isCompleted ? 'Completed!' : 'View progress'}
            </Button>
          ) : (
            showStartButton &&
            onClickStart && (
              <Button
                variant="contained"
                style={{
                  borderRadius: '30px',
                }}
                onClick={(ev) => {
                  ev.stopPropagation();
                  onClickStart();
                }}>
                Start
              </Button>
            )
          )}
        </div>
      </Card>
    </div>
  );
};

SharedProgrammeCard.propTypes = {
  sharedProgrammeId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  shortDescription: PropTypes.string.isRequired,
  coverImageUrl: PropTypes.string.isRequired,
  needsMembershipUpgrade: PropTypes.bool.isRequired,
  onClickSharedProgramme: PropTypes.string.isRequired,
  cardWidth: PropTypes.number,
  isEnrolled: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  showStartButton: PropTypes.bool,
  onClickStart: PropTypes.func,
};

SharedProgrammeCard.defaultProps = {
  cardWidth: null,
  showStartButton: false,
  onClickStart: null,
};

export default SharedProgrammeCard;
